import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <span className="inline-block px-4 py-1.5 bg-background-200 text-foreground-600 text-xs font-medium rounded-full mb-6">
              About GTBuy
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
              Why Spreadsheet Shopping Systems Matter
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              Traditional online shopping is fragmented and overwhelming. Spreadsheet-based shopping systems like GTBuy Spreadsheet, Kakobuy Spreadsheet, and Superbuy Spreadsheet change the game by providing structured, organized product data that helps you compare items faster, track updated listings in real time, and avoid outdated or unreliable information.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Whether you are a casual browser looking for the latest sneakers or a power shopper who wants deep product comparisons, our spreadsheet hub connects you to the right tools. Each system offers unique strengths in data depth, update speed, and ease of use so you can pick the one that fits your shopping style.
            </p>
            <Link
              to="/gtbuy-spreadsheet-ultimate-guide"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              Read the Full Guide
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden bg-accent-800 p-8 md:p-10">
              <div className="absolute top-6 left-6">
                <span className="text-xs text-background-50/40 font-medium uppercase tracking-widest">GTBuy System</span>
              </div>
              <div className="absolute top-6 right-6 flex gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-background-50/20"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-background-50/20"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-background-50/20"></span>
              </div>

              <div className="mt-12 md:mt-16 mb-8">
                <p className="font-heading text-xl md:text-2xl text-background-50 leading-relaxed font-medium">
                  &ldquo;Spreadsheet shopping transforms how we discover products. Instead of endless scrolling, you get structured, filterable, constantly updated product data that makes every purchase decision smarter and faster.&rdquo;
                </p>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-600 flex items-center justify-center">
                    <i className="ri-user-line text-background-50 text-base w-4 h-4 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-background-50">GTBuy Team</p>
                    <p className="text-xs text-background-50/60">Spreadsheet Shopping Experts</p>
                  </div>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-50/10 text-background-50 text-xs font-medium rounded-full hover:bg-background-50/20 transition-colors whitespace-nowrap"
                >
                  Visit Store
                  <i className="ri-arrow-right-up-line text-xs w-3 h-3 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}